<rid-sentence-reading-base
  [title]="'Focuslezen'"
  [sentencesMatrix]="sentencesMatrix()"
  [pace]="pace()"
  [doSentencePass]="doSentencePass.bind(this)"
  (finished)="finished.emit()"
/>
